const defaultTenantId = 'dev88851';

const pathname = window.location.pathname;
const segments = pathname.split('/');

const tenantSegment = segments.length > 1 && segments[1] ? segments[1] : undefined;

let parsedTenant = defaultTenantId;

if (tenantSegment && /^[a-zA-Z0-9-]+$/.test(tenantSegment)) {
  parsedTenant = tenantSegment;
}

export const TenantId = parsedTenant;
